import { Grid, Typography } from "@mui/material";
import React from "react";
import AmountUtils from "../../Utils/AmountUtils";

export default function ProductCardWithQuantityFullWidth(props) {
  const product = props.data;
  return (
    <>
      <Grid
        container
        sx={{
          display: "flex",
          padding: "8px",
          height: "90px",
          background: "#FFFFFF",
          width: "100%",
        }}
      >
        <Grid
          item
          xs={2}
          sx={{
            height: "100%",
          }}
        >
          <img
            src={product?.productImage}
            alt=""
            width={"100%"}
            height="100%"
          />
        </Grid>
        <Grid
          item
          xs={7}
          sx={{
            paddingLeft: "10px",
            height: "100%",
            width: "100%",
            display: "flex",
            flex: "1",
            flexDirection: "column",
          }}
        >
          <Typography
            sx={{
              wordBreak: "break-all",
              fontWeight: "400",
              fontSize: "12px",
            }}
          >
            {product?.productName}
          </Typography>

          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "12px",
              color: "#333333",
            }}
          >
            Quantity - {product?.quantity}
          </Typography>
        </Grid>
        <Grid
          item
          xs={3}
          sx={{
            paddingLeft: "10px",
            height: "100%",
            alignContent: "center",
          }}
        >
          <Typography
            sx={{
              color: "#00733E",
              fontWeight: "600",
              fontSize: "14px",
              textAlign: "center",
            }}
          >
            {AmountUtils.formatCurrency(props.amount)}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
